import { render, staticRenderFns } from "./uppy_contractor.vue?vue&type=template&id=049fdf12&scoped=true"
import script from "./uppy_contractor.vue?vue&type=script&lang=js"
export * from "./uppy_contractor.vue?vue&type=script&lang=js"
import style0 from "./uppy_contractor.vue?vue&type=style&index=0&id=049fdf12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fdf12",
  null
  
)

export default component.exports